import { render, staticRenderFns } from "./AssignToGroup.vue?vue&type=template&id=1485b3ad&"
import script from "./AssignToGroup.vue?vue&type=script&lang=js&"
export * from "./AssignToGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports